import { useSyncExternalStore } from 'react';

/** 미니멀 헤더 우측 슬롯 DOM 을 공유하는 최소 외부 스토어 — 레이아웃이 등록, 페이지가 구독해 포털. */
let element: HTMLElement | null = null;
const listeners = new Set<() => void>();

export function registerHeaderRightSlot(el: HTMLElement | null): void {
  element = el;
  listeners.forEach((l) => l());
}

export function useHeaderRightSlot(): HTMLElement | null {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => element,
    () => null,
  );
}
